// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCB56XhOGgOCjzK74QgIWEgNAGcJriBPaE",
  authDomain: "cadi-ifh.firebaseapp.com",
  projectId: "cadi-ifh",
  storageBucket: "cadi-ifh.firebasestorage.app",
  messagingSenderId: "867343463019",
  appId: "1:867343463019:web:5e179d1793b6c19e9ab72e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export {app};